import { render, staticRenderFns } from "./detail-clear.vue?vue&type=template&id=281fe4fc&scoped=true&"
import script from "./detail-clear.vue?vue&type=script&lang=js&"
export * from "./detail-clear.vue?vue&type=script&lang=js&"
import style0 from "./detail-clear.vue?vue&type=style&index=0&id=281fe4fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281fe4fc",
  null
  
)

export default component.exports